import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LanguageSwitcher } from '../components';
import './Dashboard.css';

export function Dashboard() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { user, logout, isLoading } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const isRTL = i18n.language === 'fa';

  // Handle redirects in useEffect to avoid React warnings
  useEffect(() => {
    if (!isLoading) {
      if (!user) {
        navigate('/login');
      } else if (user.role === 'teacher') {
        navigate('/teacher');
      } else if (user.role === 'student') {
        navigate('/student');
      }
    }
  }, [user, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className={`dashboard-page ${isRTL ? 'rtl' : 'ltr'}`}>
        <div className="dashboard-loading">
          {t('common.loading')}
        </div>
      </div>
    );
  }

  // Show loading while redirecting
  if (!user || user.role === 'teacher' || user.role === 'student') {
    return (
      <div className={`dashboard-page ${isRTL ? 'rtl' : 'ltr'}`}>
        <div className="dashboard-loading">
          {t('common.loading')}
        </div>
      </div>
    );
  }

  // This dashboard is for admins only now
  const roleLabel = i18n.language === 'fa' ? 'مدیر' : 'Admin';

  return (
    <div className={`dashboard-page ${isRTL ? 'rtl' : 'ltr'}`}>
      <header className="dashboard-header">
        <div className="dashboard-header-content">
          <a href="/" className="dashboard-logo">
            <img src="/logo-header.png" alt="SolarMaktab" />
          </a>
          <div className="dashboard-header-actions">
            <LanguageSwitcher />
            <button onClick={handleLogout} className="logout-btn">
              {t('common.logout')}
            </button>
          </div>
        </div>
      </header>

      <main className="dashboard-main">
        <div className="dashboard-container">
          <div className="welcome-section">
            <h1>
              {t('common.welcome')}, {user.name || user.email}!
            </h1>
            <p className="user-role">
              {roleLabel}
            </p>
          </div>

          <div className="dashboard-cards">
            <div className="dashboard-card">
              <div className="card-icon">📖</div>
              <h3>{i18n.language === 'fa' ? 'کتابخانه من' : 'My Library'}</h3>
              <p>{i18n.language === 'fa' ? 'مشاهده درس‌های در دسترس' : 'View available lessons'}</p>
              <button className="card-btn" disabled>
                {i18n.language === 'fa' ? 'به زودی' : 'Coming Soon'}
              </button>
            </div>
            <div className="dashboard-card">
              <div className="card-icon">🏫</div>
              <h3>{t('schools.title')}</h3>
              <p>{i18n.language === 'fa' ? 'کشف و عضویت در مدارس' : 'Discover and join schools'}</p>
              <button className="card-btn" disabled>
                {i18n.language === 'fa' ? 'به زودی' : 'Coming Soon'}
              </button>
            </div>
            <div className="dashboard-card">
              <div className="card-icon">📥</div>
              <h3>{t('content.download')}</h3>
              <p>{i18n.language === 'fa' ? 'دانلود برای استفاده آفلاین' : 'Download for offline use'}</p>
              <button className="card-btn" disabled>
                {i18n.language === 'fa' ? 'به زودی' : 'Coming Soon'}
              </button>
            </div>
          </div>

          <div className="coming-soon-notice">
            <p>
              {i18n.language === 'fa'
                ? '🚧 داشبورد در حال توسعه است. قابلیت‌های بیشتر به زودی اضافه خواهند شد.'
                : '🚧 Dashboard is under development. More features coming soon.'}
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
